module.exports = new __parcel__URL__("teams-icon.7e043335.svg").toString();